import constant from './modules/constant/constant_en'
import file from './modules/file/file_en'
import table from './modules/table/table_en'
import operationLog from './modules/oplog/operationLog_en'
import search from './modules/search/search_en'
import placeholder from './modules/placeholder/placeholder_en'
import errMsg from './modules/error/errMsg_en'
import qbLog from './modules/oplog/qbLog_en'
import confirm from './modules/confirm/confirm_en'
import html from './modules/constant/html_en'
import order from './modules/order/order_en'
import payLog from './modules/oplog/PayLog_en';
import store from './modules/store/store_en';

export default {
  message: {
    modiyAccountError:"No, the account has been modified",//拒绝，该账号已被修改
    expirationData:'Expiration data',//到期数据
    orderData:"Order data",//订单数据
    qbData:"QB data",//qb数据
    imeiCard:"Imei Card",//卡imei
    iccidCard:"Iccid Card",//卡iccid
    recentlyLoggedOut:"Last time you logged out",//最近一次登出时间
    recentLogin:"Last login time",//最近一次登录时间
    taskUser:'Task user',//任务用户
    taskManagement:'Task management',//任务管理
    taskManage:'Task management',//任务管理
    patrolFile:'Document management',//文件管理
    patrolEvent:'Report an event',//上报事件
    patrolSignCount:'Check-in statistics',//签到统计
    patrolStatistics:'Patrol statistics',//巡更统计
    patrolUserPlan:'Set user plan',//设置用户计划
    patrolPlanUser:'View user plan',//查看用户计划
    patrolPlanGroup:'Patrol planning group',//巡更计划组
    patrolPlan:'Patrol plan',//巡更计划
    patrolGroup:'Patrol point group',//巡更点分组
    patrolPoints:'patrol Points',//巡更点
    patrolManage:'patrol Manage',//巡更管理
    entManage808:'conversion equipment',//808转换设备
    track808:'808manage',//808id管理
    decorationIndex:"decorationIndex",
    priceRecord:"price action record",//价格操作记录
    allocateToTarget:"Allocate currency to target",//把货币分配给目标
    RecycleFromTarget:"Recycle the distributed currency from the target",//把分出去的货币从目标上回收
    targetBalance:"Target Balance",//目标账号余额
    currentBalance:"Current Balance",//当前账号余额
    virtualCurrency:"Virtual Currency",//虚拟货币
    myBalance:"My Balance",//我的余额
    enterpriseBalance:"Enterprise balance",//企业余额
    doNotAddingFeatures:"Do not choose the renewal duration when only adding features",//只增加功能时不要选择续签时长
    selectTargetCom:"Please select target company！",//请选择目标企业
    numberOfAccountsCannotEqual:"The number of accounts changed cannot be equal to the number of owned accounts!",//改签账号数不能等于拥有数
    purchaseOrderFailed:"Purchase order failed, insufficient balance!",//购买订单失败，余额不足！
    changeAccountNumberCannotBeLessThan1:"Change account number cannot be less than 1",//改签账号不能小于1
    maximumOrderQuota:"Maximum order quota",//订单名额上限
    organizationAuthority: 'Organization Authority',//组织权限
    entManage: 'Private Network Manage',//企业专网
    privateNetworkManage: 'Private Network Manage',//专网管理
    pnIDManage: 'Private network management',//专网id管理
    secmerSave: 'Scan the new',//secmerSave
    secmerOrganization: 'Agent Organization',//子代理的组织转移
    secmerCheckinIccid: 'Iccid export ',//iccid数据导出
    seconOrganization: 'Organization Structure',//二级管理组织结构
    seconErpriseRelevanList: 'Linked list',//二级企业关联列表
    seconErpriseRelevan: 'Associated group',//二级群组关联
    seconErpriseOrgan: 'Organize group',//二级组织群组
    seconErpriseMonitor: 'Monitor',//二级监听
    orderUserBindLog: "change bond record",
    organManagement: 'organization and management',//组织管理
    terminalMonitor: 'Terminal to monitor',//终端监听
    relevanceGroupList: 'relevanceGroupList',//关联列表
    relevanceGroup: 'Relevance Group',//关联群组
    groupOrganization: 'Group Organization',//群组组织
    OrganizationalManagement: 'Organizational Management',//组织管理
    groupStructure: 'Group Structure',//群组组织
    enterpriseOrganization: 'Enterprise Organization',//企业组织转移
    agentOrganization: 'Agent Organization',//代理组织转移
    organizationStructure: 'Organization Structure',//组织结构
    queryProxyCheckinData: 'Iccid export',//代理iccid数据导出
    orderLog: "orderLog",//订单记录
    orderBuildLog:'orderBuildLog',//换绑记录
    transaction: "transaction",
    rebate: 'rebate',
    storePricing: 'storePricing',
    menuManagement: 'menuManagement',
    storeDispatch: 'dispatch',
    recharge: 'recharge',
    storeManagement: 'storeManagement',
    CodeError: "Verification code error",//验证码错误
    lifelongUser: 'The user agreement',//终身用户
    PayLog: "transaction log",//交易日志
    OrderList: "order management",//订单管理
    order: "Order Center",
    orderForm: "Place an order",
    targetEnterprise: 'Target enterprise',//目标企业
    groupNameEmpty: 'Group name cannot be empty',//群组不能为空
    createGroup: 'Create a new group',//创建新群组
    idRules: 'id just Numbers',//id只能是数字
    fileRules: 'Only upload .txt files',//只能上传.txt文件
    toGenerateData: 'To generate data',//要生成数据
    postposition: 'postposition',//后置
    preposition: 'preposition',//前置
    aTotalQB: 'A total QB',//共需QB
    inputData: 'Input Data',//输入数据
    wrongData: 'Wrong Data',//有错误数据
    qdivide: 'Q-coins Divide',//Q币划分
    pleaseEndData: 'Please Enter End Data',//请输入结束数据
    pleaseStartData: 'Please Enter Start Data',//请输入开始数据
    iccidRules: 'Only 20 digits or letters can be entered, and the last 4 digits can only be Numbers',//只能输入20个数字或者字母组成的数据,后4位只能是数字
    onlyNumberOrLetters: 'Only 20,14,15,19 Numbers or letters can be entered in a row',//一行只能输入20个数字或者字母
    onlyNumber: 'Only Numbers',//只能是数字
    batchRules:'Note: 1, import Excel support Q coin division and order binding \n\n 2, the number of Q coins shall be subject to the number of Q coins in the first data, and the order number shall be subject to the first data order number \n\n 3. Refer to the instructions on the second page for specific table items',
    //注: 1，导入Excel支持Q币划分和订单绑定
    //  2，Q币的数量以第一条数据Q币数量为准，订单号以第一条数据订单号为准
    //  3，具体表格项查看第二页说明书
    passwordRules: 'Not Enter Default Password',//*不输入默认为123456
    uploadRules: 'Only upload. TXT file (notepad), where each line of data consists of 20 Numbers or letters.Select file upload, IMEI creation and iccid serial number creation can not have data, click upload to the server to save data directly',
    dataNoEmpty: ' Data Cannot Be Empty',//数据不能为空
    uploadService: 'Upload To Service',//上传到服务器
    selectFile: 'Select upload file',//选取文件
    iccidSerial: 'Iccid Serial Number Creation',//iccid连号创建
    imei: 'IMEI Creation',//IMEI创建
    imeiRangeOfNew: 'Imei Range Of New',//imei区间新增
    imeiDownloadTemplate: 'Imei Download the template',//imei模板下载
    modelName: 'Machine model',//机器型号
    tmodelName: 'Terminal Model',
    mgtPswd: 'mgt Passwor',
    smodelName: 'Software Model',
    sVer: 'Software Model',
    accountStartData: 'Account data',//账号起始数据
    enterAccountStartData: 'Enter Account start data',//请输入账号起始数据
    enterModelId: 'Enter model ',//请输入机器型号
    deleteImeiError: 'The user is bound and cannot be deleted',//已经绑定用户，不能删除
    clearEchoData: 'Clear echo data',//清除回显数据
    modelId: 'Machine ID',//机器id
    addModel: 'Add model',//添加机型
    CheckOutProblem: 'Check not pass',//校验不通过
    bindModel: 'Model of binding machine',//绑定机器型号
    confirmLifeTime: 'Determine lifetime binding',//确定终身绑定
    BindLifeTime: 'Bind LifeTime',//绑定终身
    UnbindLifeTime: 'Unbind lifeTime',//解除终身绑定
    yes: 'yes',//是
    no: 'no',//否
    noAuthority: 'have no right ',//没有权限
    failed: 'failed',//失败
    success: 'success',//成功
    batch: 'batch',//批次
    userId: 'User Id',//用户id
    queryGroup: 'query Group',//群组查询
    enterpriseId: 'Enterprise Id',//企业id
    imeiHint: 'If no batch is selected, all data is exported',//如果不选批次，导出的是所有的数据
    flagStartNumber: 'Identification Starting Number',//标识起始数据
    firstName:'Starting name',//起始名称
    userPassword:'user password',//用户密码
    companyName: 'Company Name',//公司名称
    userNameFlag: 'User Name Identification',//用户名称标识位置
    batchOrder:'Order',//订单
    accountImei:'Account imei',//账号IMEI
    createAccountImei:'The account imei was added',//账号imei新增
    iccidSerialNumber:'iccid Serial number',//iccid连号
    txtTextUpload:'txt text upload',//txt文本上传
    numberCreationMode:'Number creation mode',//创号方式
    establishedGroup:'Established group',//已建群组
    newGroup:'Add group',//新增群组
    paymentMethod:'payment method',//缴费方式
    groupName:'Group name',//群组名称
    flagExplain:' Identification data is used together with the start name',//*标识数据和起始名称一起使用，前置是放在名称前面，依次递增，例如: 起始名称：张三，标识数据：1，前置，用户名称为：1张三，2张三等
    iccidCreateUser: 'The interval can only generate 100 users at most',//区间最多只能生成100个用户
    accountToBeTransferred: 'AccountToBeTransferred',//待转移账号
    halt: 'Halt',//停机  断网
    haltSuccess: 'HaltSuccess',//断网成功
    activationSuccessful: 'ActivationSuccessful',//激活成功
    cardStatus: 'CardStatus',//卡状态'
    restorationNetwork: 'Restoration Network ',//恢复网络
    restorationNetworkSuccess: 'restorationNetwork',//恢复成功
    trafficQuery: 'Traffic query',//流量查询
    accessNumber: 'IotCard',//物联网卡断号
    activate: 'Activate',//激活
    unbundlingSuccess: 'Unbund Success',//解绑成功
    bindingSuccess: 'bindingSuccess',//绑定成功
    operator: 'operator',//运营商
    binding: 'Bind',//绑定
    unbundle: 'unbundle',//解绑
    refresh: 'Refresh',//刷新
    ends: 'Dnd Data',//结束数据
    begin: 'Begin Data',//开始数据
    common: "Common Data",//"公共数据",
    Rangeofnew: 'Range Add ',//区间新增
    iccid: 'Iccid',//iccid卡号
    iccidmanage: 'ICCID　MGT',//iccid卡管理
    checkinIccid: 'Iccid export',//iccid导出
    zenterprisemanage: 'Enterprise MGT',//总代企业管理
    PleaseSelecTheIccidToDelete: 'Please select the iccid to delete',//请选择要删除的iccid
    Transfer: 'Account Transfer',//账号转移
    qbMust0: "Qb must be greater than 0",//请输入大于0的数
    qbLess: 'Qb is less than greater than 0',//Q币回收
    qbRecycling: 'Coin Recycle',
    Digitalpublicnetworkintercom: "Digital Public Network Intercom", //公网数字对讲机
    ModifyMaterial: "Edit Account", //修改资料
    ModifyInfo: "Modify Info", //修改信息
    Location: "Location", //当前位置
    BatchAddGroup: "Batch Add Group", //新增群组
    AlreadyAddGroup: "Already Add",//已添加群组
    AlreadyAddUser: 'Already Add User',//已添加成员
    WaitAddGroup: "Wait Add",//待添加群组
    WaitAddUser: "Wait Add User",//待添加成员
    login: "Login",//登录
    Add: "Add", //添加
    Delete: "Delete", // 删除
    signOut: "Logout", //退出
    copy: "Copy", //复制
    copyAll: "Copyall", //全部复制
    copySuccess: "Coppy Sucessful",//复制成功
    currentGroupName: "currentGroupName", //当前群组
    domainName: "Domain name", //域名
    DomainName: "Domain MGT", //域名管理
    DomainNameManage: "Domain  MGT", //域名管理
    enterDomainName: "Input domain name", //请输入域名
    BrandManage: "Brand MGT", //品牌管理
    model: "Model", //品牌管理
    modelmanage: "Model MGT", //品牌管理
    expirationReminder: "Expiration Reminder",//到期提醒
    locationManagement: "Location Management",//位置管理
    PleaseSetTheUploadTime: 'Please set the upload time',//请设置上传位置时间
    name: "Name", //名称
    accountType: "Account Type", //帐户类型
    hello: "Hello", //您好
    account: "Account", //账号
    imeiAccount: "Imei Account",//imei号
    newAccount: "New Account",//新账号
    oldAccount: "Old Account",//旧账号
    states: "Status", //状态
    phone: "Phone", //手机
    money: "Amount", //金额
    email: "Email", //邮箱
    eamil: "Email", //邮箱
    password: "Password", //密码
    company: "Company", //公司
    proxy: "Agent", //代理
    proxyAccount: "Agent Account", //代理账号
    proxyName: 'Agent Name',//代理名称n
    subProxyAccount: "SubAgent account",//子代理账号
    subProxyName: "SubAgent name",//子代理名称
    address: "Address", //地址
    operate: "Operate", //操作
    edit: "Edit", //编辑
    detail: "Detail", //详情
    create: "Create", //新增
    countCompany: "Company No.", //企业数量
    countTerminal: "User No.", //用户数量
    remainQMoney: "Remaining Q Coin", //剩余Q币
    query: "Search", //查询
    history: "History", //历史记录
    manage: "Manage", //管理
    storeManage: "store manage", // 虚拟货币管理
    log: "Log", //日志
    normal: "Normal", //正常
    Arrears: "Expired", //欠费
    pause: "Paused", //暂停
    reset: "Reset", //
    queryAll: "Check All",
    delete: "Delete", //删除
    return: "Return", //返回
    resetpassword: "ResetPassword", //重置密码
    allocationPasswordReset: "Allocation password reset",//分配密码重置
    index: "No.", //序号
    dateTime: "Date", //日期
    TEL: "Tel", //固话
    province: "Province", //省份
    city: "City", //城市
    county: "Area/County", //区/县
    provincecitycounty: "Province/City/Area",
    street: "Street", //街道
    remark: "Remark:", //备注
    register: "Register", //注册
    cancel: "Cancel", //取消
    save: "Save", //保存
    AgencyManagement: "Agent　MGT", //代理管理
    ProxyDetail: "Agent Info", //代理详情
    BatchOperation: "Batch operate", //批量操作
    Certain: "Confirm", //确定
    identityCard: "ID Card", //身份证
    enterYouAccount: "Input Account", //请输入账号
    enterYouEnterpriseAccount: 'Input Enterprise Account',//请输入企业账号
    enterYouProxyAccount: 'Input Proxy Account',//请输入代理账号
    enterYouMoney: "Input Amount", //请输入金额
    enterYouEmail: "Input Email", //请输入邮箱
    enterYouPhone: "Input Phone", //请输入手机
    enterYouEamil: "Input Email", //请输入邮箱
    enterYouTel: "Input Tel: XXXX-XXXXXXX", //请输入固话
    enterYouCompanyName: "Input Company Name", //请输入公司名称
    enterYouStates: "Select Status", //请选择状态
    enterYouDateTime: "Select Time", //请选择时间
    SelectProvince: "Select Province", //请选择省份
    SelectCity: "Select City", //请选择城市
    SelectCounty: "Select Area/County", //请选择区/县
    SelectStreet: "Input Street", //请输入街道
    enterproxy: "Input Agent", //请输入代理
    selectproxy: "Select Agent", //请选择代理
    selectenterprise: "Select Enterpries",//请选择企业
    enteridentityCard: "Input ID Card", //请输入身份证
    enterName: "Input Name", //请输入名称
    enterICCId: "Input Iccid",//请输入ICCID
    enterIMEI: 'Input Imei',//请输入imei
    enterRemark: "Input Remark", //请输入备忘
    enterYouPassWord: "Input Password", //请输入密码
    reEnter: "Re-input", //再次输入
    reEnterYouPassWord: "Re-input Password", //请输入密码
    enterYouVerificationcode: "Input Verification Code", //请输入验证码
    // 以下账号 管理
    AccountManage: "Account MGT", //账号管理
    jurisdiction: "User Right", //权限

    AccountType: "Type", //类型
    type: "Operation Type", //操作类型
    createDate: "Create Time", //创建日期
    modifyDate: "Modify Time", //修改时间
    expiredDate: "Expired Time", //到期日期
    iccId: "IccId", //iccId
    iccidUser: "Scan the new ",//账号生成
    imeiimportexcel: "IMEI is newly added",//IMEI新增
    imeiinfo: "IMEI info query",//imei信息
    lifefreeimportexcel: "Lifelong import",//终身免费批增
    messageQuery: "Info Search", //信息查询
    SelectJurisdiction: "Select", //请选择
    PleaseSelect: "Select", //请选择
    //操作记录
    SystemManage: "System MGT", //系统管理
    OperationRecord: "Operation Logs", //操作记录
    orderRecord: "Operation Record", //订单记录
    OperationType: "Operation Type", //操作类型

    DeleteUser: "Delete User", //删除用户
    ModifyUser: "Modify User", //修改用户
    AddGroup: "Add Group", //新增群组
    ModifyGroup: "Modify Group", //修改群组
    DeleteGroup: "Delete Group", //删除群组
    AddFriend: "Add Friend", //新增好友
    DeleteFriend: "Delete Friend", //删除好友

    //自己新增
    AddEnterprise: "Add Enterprise", //新增企业
    DeleteEnterprise: "Delete Enterprise", //删除企业
    ModifyEnterprise: "Modify Enterprise", //修改企业

    // ----统计信息
    increaseCount: 'Increase Count',//增长统计
    onlinenumber: 'Count online number',//在线数量
    TotalManage: "Statis Infos", //统计信息
    TotalProxy: "Agent No.", //代理总数
    RegUser: "Registerd User", //注册用户
    UseUser: "QB Used User", //使用用户
    totalUseUser: "Total Used User",  //使用用户
    OnLineUser: "Online User", //在线用户
    OneMonthOverdueCount: "One Month Overdue Count",//过期一个月数量
    OneWeekOverdueCount: "One Week Overdue Count",//过期一个周
    AboutAWeekOverdueCount: "About Week Overdue Count",//快过期一周数量
    AboutAMonthOverdueCount: "About Month Overdue Count",//快过期一个月数量
    About3MonthOverdueCount: "3 Month Overdue Count",//快过期一个月数量
    oneWeekOverdueCountAdd: "One Week Overdue Count Add",//快过期一个月+
    OneMonthOverdueCountQB: "欠费1月",//过期一个月数量
    OneWeekOverdueCountQB: "欠费1周",//过期一个周
    AboutAWeekOverdueCountQB: "1周后到期",
    AboutAMonthOverdueCountQB: "1月后到期",//快过期一个月数量
    oneWeekOverdueCountAddQB: "欠费1月+",//欠费一个月以上
    //特殊播报
    BroadCast: "Broadcast", //特殊播报
    Matter: "Content", //内容
    ENterMatter: "Input Content", //清输入内容
    //Q币
    RechargeValueQ: "Coin Add",///Q币充值
    RechargeValueMoney: "Add Amount", //充值金额
    OldPassWord: "Old Password", //旧密码
    NewPassWord: "New Password", //新密码
    PWD: "Password", //密码
    EnterMoney: "Input Amount", //请输入金额
    QManage: "Q Coin MGT", //Q币管理
    QDistribution: "Coin Alloc", //Q币分配

    CurrBalance: "Balance", //当前余额
    CurrentBalanceDeficiency: "Insufficient Balance", //当前余额不足
    setting: "Setting", //设置
    //Q币日记
    QLog: "Coin Logs", //Q币日志
    DealQ: "Transaction Q Coin Amount", //交易Q币数
    DealDate: "Transaction Time", //交易时间
    Operator: "Operator", //操作人
    User: "User",//用户
    EPAccount: "Company Acount:", //企业账号
    EPName: "Enterprise Name",//企业名称
    TerminalAccount: "Terminal Account",//终端账号
    TerminalName: "Terminal Name",//终端名称
    //Q币交易记录
    DealRecord: "Transaction Logs", //交易记录
    Place: "Allocate", //划分
    Recover: "Reclaim", //回收
    QNumber: "Q Coin No.", //Q币数
    Export: "Export", //导出
    //Q币管理
    CurrProxyRemainQ: "{type, select ,1{Main agent Q Coin balance} 2{Current agent Q Coin balance}  other{}}",   //当前总代余额Q币
    CurrMerchantRemainQ: "Current agent Q Coin balance", //当前代理余额Q币
    TargetProxyRemainQ: "{type, select ,1{Target agent Q Coin balance} 2{Target sub-agent Q Coin balance} other{}} ",   //当前总代余额Q币
    TargetEnterpRemainQ: "Target company Q Coin balance", //目标企业余额Q币
    Explain: "Specification", //说明
    PlaceRecoverQ: "{type,select,1{Distribute Q Coin} 2{Reclaim Q Coin} other{Distribute/Reclaim Q Coin}} ", //划分/回收Q币
    PlaceExplain: "{role,select,1{Distribute: Distribute Q Coin to agent} 2{Distribution: distribute Q COINS to the sub-agent} 5{Distribute: Distribute Q Coin to agent}  8{Distribution: distribute Q COINS to the sub-agent}other{}} ",//划分/回收Q币

    EnterQNumber: "Input Q Coin No.", //请输入Q币数
    // PlaceExplain: "Distribute: Distribute Q Coin to agent", //划分:把Q币分配给代理
    PlaceExplains: " Allocation: distribute Q COINS to the sub-agent",//划分：把Q币分配给子代理
    //   RecoverExplain: "Reclaim: Reclaim the distributed Q Coin from the agent", //回收：把分出去的Q币从代理收回
    RecoverExplain: "{role,select,1{Reclaim: Reclaim the distributed Q Coin from the agent} 2{Reclaim: Reclaim the distributed Q Coin from the sub-agent} 5{Reclaim: Reclaim the distributed Q Coin from the agent}  8{Reclaim: Reclaim the distributed Q Coin from the sub-agent} other{}} ",//划分/回收Q币
    //子代理统计
    TotalChildProxy: "SubAgent No.", //子代理总数
    TotalEnterprise: "Company No.", //企业总数
    //子代理管理
    SubagentManagement: "SubAgent MGT", //子代理管理
    //企业管理
    EnterpriseManage: "Company MGT", //代理--企业管理
    SECENTERPRISEMANAGE: "Company MGT", //子代理--企业管理
    UserNumber: "User No.", //用户数量
    EnterpriseDetail: "Company Info", //企业详情
    //子代理详情
    SecMerchangDetail: "SubAgent Info", //子代理详情/
    funs: "Function", //功能
    userFuns:"User funs",//用户功能
    SingleCall: "Single Call", //单呼
    Position: "Location", //定位
    Friend: "Friend", //好友
    Record: "Recording", //录音
    //---二级管理
    SecEnterprise: "Department MGT", //二级管理
    //群组管理
    Group: "Group", //群组
    CurGroup: "Current Group", //群组
    GroupFuns: "Secondary group", //群组功能 改为二级群组
    GroupType: "Group Type", //群组类型
    GroupManage: "Group　MGT", //群组管理
    NormalGroup: "Normal Group", //普通群
    TemporaryGroup: "Temporary Group", //临时群
    NestingGroup: "Nested group", //嵌套群
    //代理  Q币管理
    SecPlaceExplain: "Distribute: Distribute Q Coin to company", //划分:把Q币分配给企业
    SecRecoverExplain: "Reclaim: Reclaim the distributed Q Coin from the company", //回收：把分出去的Q币从企业收回
    //企业的账号管理
    UserManage: "User　MGT", //用户管理
    usermanage: "User　MGT", //用户管理
    //企业--统计信息
    TotalGroup: "Total group No.", //群组总数

    //用户管理
    onLine: "Online", //在线
    Thisaccountalreadyexistspleaseenteragain: "Existing account, input again", // 该账号已存在，请重新输入
    Pleaseenteragainbeforeandafteraccountnumber: "Same account, input again", // 前后账号一致，请重新输入
    UserDetail: "User Info", //用户详情
    friendmanage: "Friends", //好友管理
    TalkLevel: "Call Level", //通话等级
    RechargeValue: "Top up", //充值
    WaitAddFriend: "Friends To Add", //待添加好友
    AlreadyAddFriend: "Friend added", //已添加好友
    CurrSecEnterprise: "Current Department MGT", //当前二级管理
    CancelSecEnterprise: "Cancel Department MGT", //取消二级管理
    PleaseSelectAdvocateSearch: "Pls Select, Support Search", //请选择,支持搜索
    AddUser: "Add User", //新增用户
    QUANSHENGGONGSI: "Quansheng Electronics Co., Ltd.", //福建泉盛电子有限公司
    ModifyStatus: "Modify Status", //修改状态
    Low: "Low", //低
    Middle: "Medium", //中
    High: "High", //高
    ExtraHigh: "Extra-High", //特高
    BatchImport: "Batch Import", //导入与导出/
    Import: "Import", //导入
    downloadtemplate: "Download Template", // 下载模板
    //Q币分配
    DivisionQ: "Coin Allocation", //Q币分配
    EnterpriseWaitQ: "Company Q Coin  For Alloction", //企业待分配Q币
    EnterpriseAlreadyQ: "Company Q Coin Allocted", //企业已分配Q币
    //百度地图
    start: "Start", //开始
    stop: "Stop", //停止
    UserPosition: "Location MGT", //用户定位
    //录音管理
    RecordingManagement: "Record  MGT", //录音管理
    BatchPlay: "Batch play", //批量播放
    BatchDownload: "BatchDownload", //批量下载
    Play: "Play", //播放
    BatchDel: "Batch Delete", //批量删除

    Timing: "Timing", //时长
    //档案数据
    FilesData: "Data MGT", //档案数据
    lengths: "It's Not 20 Long Enough",//长度不够20
    SaveAndModifySuccess: "Add/Save Success!", // 新增/保存成功！
    DeleteSuccess: "Delete Success!", //删除成功
    OperateSuccess: "Enable Success!", //启用成功！
    PauseSuccess: "Suspend Success!", //暂停成功！
    SwitchSuccess: "Switch Success!", //切换成功
    ResetSuccess: "Reset Success!", //重置成功！
    Hint: "Remind", //提示
    NormalStateCannotDeletePleaseStopFirst: "Normal status, cannot delete. Stop using first!", //正常状态，无法删除！请先停用
    DomainNameAndUserIdAndMerchantLevel: "Select user or domain name", //请选择用户或域名
    PauseStateCannotBeUsedPleaseEnableFirst: "Suspended status, cannot use. Enable first!", //暂停状态，无法使用！请先启用

    ConfirmDeletingThisUser: "Confirm Delete?", //确认删除该用户吗
    ConfirmDeletingThisIccid: "Confirm Delete Iccid?",//确认删除该iccid卡号吗
    ConfirmSelectThisDomainName: "Confirm select this domain name?", //确认选择该域名吗
    ConfirmDeletingThisFile: "Confirm Delete The File?", //确认删除该文件吗
    ConfirmEnablingThisUser: "Confirm Enable This User?", //确认启用该用户吗
    ConfirmSuspendingThisUser: "Confirm Suspend This User?", // 确认暂停该用户吗
    ConfirmThatThisUserPasswordIsResetTo: "Confirm reset the user password as default? ", // 确认将该用户密码重置为123456吗
    Cttuapirt: "Confirm that the user assigned password is reset to default?",//确认将用户分配密码重置为: 123456 ？
    ConfirmLifetimeBindState: "Confirm change to lifetime bind state",//确认改为终身绑定状态,
    ConfirmLifetimeUnboundState: "Confirm that the lifetime binding is unbound",//确认解除终身绑定状态
    RelieveSuccess: "Relieve success",//解除成功
    BindSuccess: "Bind success",//绑定成功
    Create: "Create", //新增
    Modify: "Modify", //修改
    DetermineIfYouWantToExport: "Confirm Export?", //确定要导出
    LastWeek: "Last Week", //最近一周
    LastMonth: "Last Month", //最近一个月
    LastThreeMonths: "Last Three Months", //最近三个月
    PleaseSelectRecordingToOperate: "Select Recording!", //请选择要操作的录音
    PlayEnd: "Play Ended", //播放结束

    ConfirmDeletingThisGroup: "Confirm Delete This Group?", //确认删除该群组吗
    ConfirmEnablingThisGroup: "Confirm Enable This Group?", //确认启用该群组吗
    ConfirmSuspendingThisGroup: "Confirm Suspend This Group?", // 确认暂停该群组吗

    PleaseSelectData: "Pls Select Data!", // 请选择数据
    CanAllocateQMoneyInsufficientOperationFailed: "Insufficient Q Coin, Operate Fail!", //可分配Q币不足！操作失败！
    Implementation: "Operationing...", //执行中...
    SuccessfulOperation: "Operate Success!", // 操作成功
    FailureOperation: "Operation Failure",//操作失败
    ConfirmExportingThisRecord: "Confirm Export The Record?", //确认导出该记录吗
    PleaseEnterANumberOfCoins: "Pls Input Q Coin No.!", //请输入Q币数
    PleaseEnterANumberOfCoinsLargerThan0: "Pls Input a No. Bigger Than 0!", //请输入大于0的Q币数
    PleaseSearchTargetChildAgentFirst: "Pls Search Target SubAgent First!", // 请先搜索目标子代理
    PleaseSearchTargetAgentFirst: "Pls Search Target First!", // 请先搜索目标代理
    CurrentSubAgentBalanceIsInsufficientPleaseReEnter: "Insufficient SubAgent balance, pls re-input!", //当前子代理余额不足，请重新输入
    CurrentAgentBalanceIsInsufficientPleaseReEnter: "Insufficient agent balance, pls re-input!", //目前代理余额不足，请重新输入
    CurrentEnterpriseBalanceIsInsufficientPleaseReEnter: "Insufficient company balance, pls re-input", //目前企业余额不足，请重新输入
    PlaceSuccess: "Distribute success!", // 划分成功
    PlaceTotal: "Allocation STATS", // 划分统计
    RecoverSuccess: "Reclaim Success!", //回收成功
    RecoverTotal: "Reclaim STATS", //回收统计
    BalanceCannotBeLessThan1CannotBeRecoveredPleaseReEnter: "Balance cannot be less than 1, reclaim fail, pls re-input", // 余额不能小于1，无法回收，请重新输入
    CurrentlyInsufficientBalanceOfSubAgentPleaseReEnter: "Insufficient SubAgent balance, pls re-input", //目前子代理余额不足，请重新输入
    PasswordError: "Password Error!", // 密码错误
    ConsistentPasswordBetweenOldAndNew: "New password same as old password", //新旧密码一致
    PleaseEnterEnterpriseAccountQueryFirst: "Pls input company account first!", //请先输入企业账号查询
    PleaseEnterEnterprise: "Pls Select Company!", //请先选择企业

    ConfirmDeletingThisSecEnterprise: "Confirm delete this secondary account MGT?", //确认删除该二级管理吗
    ConfirmEnablingThisSecEnterprise: "Confirm enable this secondary account MGT?", //确认启用该二级管理吗
    ConfirmSuspendingThisSecEnterprise: "Confirm suspend this secondary account MGT?", // 确认暂停该二级管理吗

    ConfirmEnablingThisTerminal: "Confirm enable this terminal?", //确认启用该终端么？
    ConfirmSuspendingThisTerminal: "Confirm suspend this terminal?", //确认暂停该终端么？

    ConfirmDeletingThisSecAgent: "Confirm delete this SubAgent?", //确认删除该子代理吗
    ConfirmEnablingThisSecAgent: "Confirm enable this SubAgent?", //确认启用该子代理吗
    ConfirmSuspendingThisSecAgent: "Confirm suspend this SubAgent?", // 确认暂停该子代理吗

    ConfirmDeletingThisBoardCast: "Confirm delete this broadcast?", //确认删除该播报吗
    ConfirmEnablingThisBoardCast: "Confirm enable this broadcast?", //确认启用该播报吗
    ConfirmSuspendingThisBoardCast: "Confirm suspend this broadcast?", // 确认暂停该播报吗

    ConfirmDownloadTemplate: "Confirm Download Template?", //确认下载模板吗
    IsOnline: "Online Or Offline", //是否在线
    OnlineStatus: [
      {id: "0", name: "Online", code: true},
      {id: "1", name: "Offline", code: false}
    ],
    simpleOrFullColumn: [
      { id: "0", name: "Simple Column",code:false },
      { id: "1", name: "Full Column",code:true }
    ],

    //登录
    Error: "Error", //错误
    PleaseCompleteTheVerification: "Pls complete the verification!", //请完成验证
    CodeCannotBeEmpty: "Verification code cannot be empty!", // 验证码不能为空
    ThisAccountHasBeenSuspendedPleaseHandle: "Account suspended, pls process it!", //该账号已暂停，请处理！
    AccountOrPasswordError: "Account or password error!", //账号密码错误
    //---------------------
    //终端管理
    TerminalManage: "Terminal MGT", //终端管理
    TerminalEvent: "Terminal Logs", //终端操作
    EnterPrise: "Company", //企业
    help: "Help", //帮助
    MenuManage: "Menu MGT", //菜单管理
    SettingDistributionPassword: "Set Distributed Password", //设置分配密码
    SetDistributionPaw: "Allocation Password", //设置分配密码
    SIMManagement: "SIM Card MGT", //SIM卡管理
    //步骤条 多语言
    stepOne: "Step One", //第一步
    stepTwo: "Step Two", //第二步
    stepSuceess: "Finish", //完成
    stepNext: "Next Step", //下一步
    //步骤条提示语
    PleaseEnterTheOldAssignedPassword: "Pls input the old distributed password!", //请输入旧的分配密码
    PleaseEnterTheNewAssignedPassword: "Pls input the new distributed password!", //请输入新的分配密码
    confirmPassword: "Confirm Password", //确认密码


    //数据统计
    DataTotal: "Data STATS", //数据统计
    MonthDataTotal: "Month data STATS", //月份数据统计
    ExAndEarTotal: "Income-expense STATS", //收支统计
    Earning: "Top Up", //充值
    Expenditure: "Expense", //支出
    AnnualBalanceOfPayments: "Annual income-expense STATS", //年度收支表
    YearDataTotal: "Annual STATS", //年度统计
    RepAndPlaTotal: "Reclaim STATS", //划回统计
    //会计管理
    AccountantManage: "Accounting MGT", //会计管理
    //会计操作记录
    AccountantEvent: "Accounting Logs", //会计操作记录
    accountUser: "Account User", //账号用户
    iccIdUser: "ICCID User", //ICCID用户
    offset: "Deviation", //偏移量
    Unbundled: "Unbind", //解绑
    Bind: "Bind", //绑定
    //企业激活统计
    EPActivateTotal: "Activity STATS", //激活统计
    EP_EPActivateTotal: "Activity STATS", //激活统计
    GA_EPActivateTotal: "Activity STATS", //激活统计
    UnitStation: "Unit/Piece", //单位/台
    Year: "Year", //年份
    Jan: "Jan", //一月
    Feb: "Feb", //二月
    Mar: "Mar", //三月
    Apr: "Apr", //四月
    May: "May", //五月
    Jun: "Jun", //六月
    Jul: "Jul", //七月
    Aug: "Aug", //八月
    Sep: "Sep", //九月
    Oct: "Oct", //十月
    Nov: "Nov", //十一月
    Dec: "Dec", //十二月
    //消息管理
    Message: "Message MGT", //消息管理
    Poop: "Message", //消息
    TerminalMessage: "Terminal message", //终端消息
    ConfirmDeletingThisMessage: "Confirm Delete This Message?", //确认删除该消息吗
    domainLibrary: "Domain Name Library", //域名库
    isNull: "Null", //暂无
    userInfo: "User Info", //用户信息
    currentDomain: "Current Domain Name", //当前域名
    seletcDomain: "Select Domain Name", //选择域名

    groupmanage: "Group　MGT", //群组管理
    groupfunc: "Group Function", //群组功能
    groupInfo: "Group Info", //群组信息
    membermgt: 'Member MGT',

    //终端事件
    MODEL_OF_DEFAULT: "MODEL_OF_DEFAULT",//默认事件
    MODEL_OF_LOGIN: "MODEL_OF_LOGIN",//登录事件
    MODEL_OF_HEARTBEAT: "MODEL_OF_HEARTBEAT",//心跳包事件
    MODEL_OF_RESPONSE: "MODEL_OF_RESPONSE",//心跳包事件
    MODEL_OF_UNKNOW_DEVICE: "MODEL_OF_UNKNOW_DEVICE",//未知设备类型事件
    MODEL_OF_LOGOUT: "MODEL_OF_LOGOUT",///登出事件
    MODEL_OF_REMOTE_FORCEDOWN: "MODEL_OF_REMOTE_FORCEDOWN",//设备强制下线事件
    MODEL_OF_MUTEXDOWN: "MODEL_OF_MUTEXDOWN",//挤下线事件
    MODEL_OF_LOCAL_FORCEDOWN: "MODEL_OF_LOCAL_FORCEDOWN",//服务器强制下线事件
    MODEL_OF_HEARTBEAT_TIMEOUT: "MODEL_OF_HEARTBEAT_TIMEOUT",//心跳超时
    MODEL_OF_EXCEPTION: "MODEL_OF_EXCEPTION",
    MODEL_OF_PROTOCOLFAULT: "MODEL_OF_PROTOCOLFAULT",
  },

  relevance: {
    groupName1: "Group Name 1",//群组名称1
    groupName2: "Group Name 2",//群组名称2
    pleaseEnterGroupName: "Please enter a group  name",//请输入群组1名称
    pleaseEnterGroupName2: "Please enter a group 2 name",//请输入群组2名称
    groupId1: "Groups of ID",//群组ID1
    groupId2: "Groups of ID2",//群组ID2
    pleaseEnterGroupId1: "Please enter group id",//请输入群组id1
    pleaseEnterGroupId2: "Please enter group id2",//请输入群组id2
    groupListen1: "Group 1 listen to",//群组1听
    groupListen2: "Group 2 listen to",//群组2听
    updateSuccessfully: "update successfully",//更新成功
    saveSuccessfully: "save successfully",//保存成功
    pleaseSelectGroup: "Please select group",//请选择群组
    pleaseSelect: "please choose",//请选择
    query: "Query",//查询
    hint: "After selecting the group, you need to click the query button and then associate",//选择群组后需要点击查询按钮,再进行关联
    groupAssociated: "Group to be associated",//待关联群组
    associatedGroup: "Associated group",//关联群组
    onlyOneGroup: "Only one group can be associated at a time",//一次只能关联一个群组
    onlyChangeOne: "Only one can be selected for deletion",//只能选择一个进行删除
  },

  patrolDictionaries:{
    patrolPointName:"Patrol Point Name",//巡更点名称
    validationalue:"Validation value",//验证值
    name:"Name",//名称
    type:"Type",//类型
    create:"Create",//新增
    remark:"Remark",//备注
    lat:"Lat",//纬度
    lon:"Lon",//经度
    distance:"Distance",//距离
    events:"Events",//事件
    edit:"Edit",//编辑
    delete:"Delete",//删除
    patrolSignIn:"Patrol SignIn",//巡更签到
    yes:"Yes",//是
    no:"No",//否
    pst:"Please select a type",//请选择类型
    scope:"Scope",//范围
    defaultMeters:"//The default unit is meters",//（单位默认为：米）
    iDCard:"iD Card",//卡id
    addResult:"Add Result",//添加结果
    dispatcherWarning:"Dispatcher warning",//调度台警告
    cancelWarning:"Cancel warning",//取消警告
    save:"Save",
    cancel:"Cancel",
  },

  button: {
    create: "Create", //创建
    createOrder: 'Create order',
    add: "Add", //新增
    update: "Update", //更新
    cancel: "Cancel", //取消
    search: "Search", //查询
    reset: "Reset", //重置
    edit: "Edit", //编辑
    submit: "Submit", //提交
    remove: "Remove",
    restore: "Restore",
    member: "Member",
    oneClickLogin: 'On-Click Login',
    confirmImport: 'Confirm import',
    sync: 'sync',
    accessSync: 'Access synchronization',//接入同步
    qbLogger: 'qbLogger',
    tradeLog: 'tradeLog',
    bind:"bind",//绑定
    sure:"sure",//确定
    expiringOrders:"expiring orders",//查询即将到期订单
    featuresAndRenewals:"Added features and renewals",//增加功能及续签
    rebook:"rebook",//改签
    activation:"activation",//激活
    orderDetails:"order details",//订单详情
    batchTermination:"Batch Termination",//批量终止
    batchFunction:"Batch Function",//批量功能
    batchOrder:"Batch Order",//批量订单
    batchQB:"Batch QB",//批量QB
    batchSecondary:"Batch Secondary",//批量二级
    batchSetting:"Batch setting",//批量设置
    unbind:"Unbind",//一键解绑
    binding:"Binding",//一键绑定
    divide:"Divide",//一键划分
    recycle:"Recycle",//一键回收
  },
  form: {
    label: {
      name: "Name:", //名称：
      pass: "Password:", //密码：
      account: "Account:", //账号：
      status: "Status:", //状态：
      phone: "Phone:", //手机号：
      checkPass: "Confirm password:", //确认密码：
      remark: "Remark", //备注
      group: {
        name: "Group name:", //群组名称：
        type: "Group type:" //群组类型：
      },
      groupId: "groupId",
      id: 'Id',
      orderId:"orderId",
      orderDuration:"orderDuration",// 订单时长
      remainingTime:"remainingTime",//剩余时长
      payerAccount:"payerAccount",//付款人账号
      payerName:"payerName",//付款人名称
      balanceBeforePurchase:"balanceBeforePurchase",//购买前余额
      balanceAfterPurchase:"balanceAfterPurchase",//购买后余额
      substitutePayerAccount:"substitutePayerAccount",//代付人账号
      substitutePayerName:"substitutePayerName",//代付人名称
      balanceBeforeSubstitute:"balanceBeforeSubstitute",//代付前余额
      balanceAfterSubstitute:"balanceAfterSubstitute",//代付后余额
      functionName:"functionName",//功能名
      unitPrice:"unitPrice",//单价
      listPrice:"listPrice", //标价
      number:"number",//个数
      durationType:"durationType",//时长类型
      duration:"duration" ,//时长
      storageTime:"storageTime",//存储时长
      payerPrice:"payerPrice",//支付价格
      ownerAccount:"ownerAccount",//所属者账号
      featureSelection:"featureSelection",//功能选择
      terminalFunctionCoverage:"terminalFunctionCoverage",//终端功能覆盖
      totalNumberOfOrderAccounts:"Total number of order accounts",// 订单账号总数
      numberOfRemainingAccounts:"Number of remaining accounts",//剩余账号数
      numberOfActivatedAccounts:"Number of activated accounts",//激活账号数
      numberOfAccounts:"Number of accounts",//账号数
      paidFeatures:"Paid features",//付费功能
      recordingStorageTime:"Recording storage time",//录音保存时长
      trackSaveTime:"Track save time",//轨迹保存时长
      activeState:"active state", //激活状态
      ChangeNumberOfAccounts:"ChangeNumberOfAccounts",//改签账号数
      affiliatedCom:"affiliatedCom",//所属企业
      targetBusiAccount:"target business account",//目标企业账号
      renewalPeriod:"Renewal period",//续签时长
      recordingSaveTime:"Recording save time",//录音保存时间
      locationSaveTime:"Location save time",//定位保存时间
      createDate:" create date",//创建时间
      startDate:"start date",//启用日期
      dateOfExpiry:"Date of Expiry",//到期日期
      totalOrderDuration:"total order duration",//订单总时长
      bindUser:"bind user",//绑定用户
      beforeTalkie:"beforeTalkie",//改前对讲价格
      afterTalkie:"afterTalkie",//改后对讲价格
      beforeDispatch:"beforeDispatch",//改前调度价格
      afterDispatch:"afterDispatch",//改后调度价格
      beforeRecord:"改前录音存储一个月",//改前录音存储一个月
      afterRecord:"改后录音存储一个月",//改后录音存储一个月
      beforeRecord1:"改前录音存储三个月",//改前录音存储三个月
      afterRecord1:"改后录音存储三个月",//改后录音存储三个月
      beforeRecord2:"改前录音存储六个月",//改前录音存储六个月
      afterRecord2:"改后录音存储六个月",//改后录音存储六个月
      beforeRecord3:"改前录音存储一年",//改前录音存储一年
      afterRecord3:"改后录音存储一年",//改后录音存储一年
      beforeLocation:"改前定位存储7天",//改前定位存储7天
      afterLocation:"改后定位存储7天",//改后定位存储7天
      beforeLocation1:"改前定位存储一个月",//改前定位存储一个月
      afterLocation1:"改后定位存储一个月",//改后定位存储一个月
      beforeLocation2:"改前定位存储三个月",//改前定位存储三个月
      afterLocation2:"改后定位存储三个月",//改后定位存储三个月
      beforeLocation3:"改前定位存储六个月",//改前定位存储六个月
      afterLocation3:"改后定位存储六个月",//改后定位存储六个月
      beforeLocation4:"改前定位存储一年",//改前定位存储一年
      afterLocation4:"改后定位存储一年",//改后定位存储一年
      beforeBroadcast:"改前广播价格",//改前广播价格
      afterBroadcast:"改后广播价格",//改后广播价格
      talkie:"对讲",//对讲
      dispatch:"调度",//调度
      F2F:"面对面建群",
      record:"录音存储1个月",//录音存储1个月
      record1:"录音存储3个月",//录音存储3个月
      record2:"录音存储6个月",//录音存储6个月
      record3:"录音存储一年",//录音存储一年
      location:"定位存储7天",//定位存储7天
      location1:"定位存储1个月",//定位存储1个月
      location2:"定位存储3个月",//定位存储3个月
      location3:"定位存储6个月",//定位存储6个月
      location4:"定位存储一年",//定位存储一年
      broadcast:"广播",//广播
      purchaseQuantity:"Purchase quantity",//购买数量
      rebateAmount:"Rebate amount",//返利金额
      orderType:"Order type",//订单类型
      pricing:"Pricing",//定价

      operatorAccount:"Operator account",//操作人账号
      operatorName:"Operator name",//操作人名称
      operatorRole:"Operator role",//操作人角色
      transactionAmount:"Transaction amount",//交易金额
      originAccount:"Origin account",//来源人账号
      originName:"Origin name",//来源人名称
      originRole:"Origin role",//来源人角色
      originBeforeBalance:"Origin before balance",//来源人操作前余额
      originAfterBalance:"Origin after balance",//来源人操作后余额
      targetAccount:"Target account",//目标人账号
      targetName:"Target name",//目标人名称
      targetRole:"Target role",//目标人角色
      targetBeforeBalance:"Target before balance",//目标人操作前余额
      targetAfterBalance:"Target after balance",//目标人操作后余额







    }

  },

  file,

  excel: {
    import: "Import Excel", //导入EXCEL
    export: "Export Excel" //导出EXCEL
  },
  zip: {
    download: {
      template: "Download Template" //下载模板
    }
  },

  validate: {
    size: {
      domainName: "Length in 2-500 characters", //长度在2到500个字符
      name: "Length in 2-10 characters", //长度在2到10个字符
      modelName: "Length in 2-50 characters", //长度在2到10个字符
      account: "Length in 6-16 characters", //长度在6-16个字符
      password: "Length in 6-15 characters",//长度在6到15个字符
      iccid: 'Length in 16 or 20 characters',//长度16或者20个字符
      begin: 'Lenth should between 1 to 3',//长度为1-3个数字
      end: 'Lenth should between 1 to 3',//1度1-3之间
      common: 'Length between 17 and 19 characters',//长度为17 到 19个字符
      flagData: 'Enter only Numbers Length in 1-6 characters',//只能输入数字,长度不能超过6位数
      imeicommon: 'The length is 9 to 12 digits',//长度为9到12个数字
      imeistart: 'The length is 2 to 5 digits',//长度为2到5个数字
      imeiend: 'The length is 2 to 5 digits',//长度为2到5个数字
      startData: 'Length in  20 characters',//长度16或者20个字符
      endData: 'Length in 20 characters',//长度16或者20个字符
      startAccount: 'The length is one character',//长度为1个数字或者字符
      remark: "Length in 0-200 characters",
      imei: "Length in 15 characters",//15数字
      isManufa:'The name contains 6 to 16 characters',//长度为6-16个数字,
      isPort:'The value contains 0 to 6 digits',//长度为0-6个数字
      isIp:'Please enter a valid IP address',//请输入合法ip
      verifyValue:'The name contains 2 to 25 characters',//长度为2-25个字符
      isNotNUll:'Data cannot be null!',//数据不能为空
      order:'Enter numbers only',//只能输入数字
    },
    warning: {
      // string:'',
      name: "Pls input name, Chinese/English/No./Underline only", //请输入名称，只能包含中文、英文、数字、下划线等字符
      domainName: "Pls input domain name, Chinese/English/No./Underline only", //请输入合法域名，只能包含中文、英文、数字、下划线等字符
      account: "Pls input account, English/No./Underline only", //请输入合法账号，只能包含英文、数字、下划线等字符
      accountHasBeenUsed: "Account being used", //账号已经被使用
      iccidHasBeenUsed: 'ICCID is used',//iccid号已被使用
      enterpriseIccid: 'The iccid does not belong to the general agent',//iccid账号不属于总代
      password: "Pls input password, length in 6-16 characters, Letter/No./Underline only", //请输入合法密码，格式以字母开头，长度在6-16之间，只能包含字母、数字和下划线
      iccid: 'Please input iccid, starting with letter, length in  20 characters',//请输入合法iccid号，长度为20个字符串,以8986(00,01,02,03,07)开头
      begin: 'Please enter the starting data with a length between 1 and 3',//请输入数字，长度在1-6之间
      end: 'Please enter the end data with a length between 1 and 3',//请输入末数据，长度在1-3之间
      imei: 'Please input imei, starting with letter, length in  15 characters',//长度为15个数字
      common: 'The length is 17 to 19 characters beginning with 8986(00,01,02,03,07)',//长度为14 到 19个字符以8986(00,01,02,03,07)开头
      flagData: 'Enter only Numbers Length in 1-6 characters',//请输入数字
      startData: 'Pls input iccid, starting with letter, length in 16 or 20 characters',//请输入合法iccid号，长度为20个字符串
      endData: 'Pls input iccid, starting with letter, length in 16 or 20 characters',//请输入合法iccid号，长度为20个字符串
      imeicommon: 'The common part is 9-12 digits long',//公共部分为9-12
      imeistart: 'The begin part is 2-5 digits long',//起始部分为2-5
      imeiend: 'The end part is 2-5 digits long',//结束部分为2-5
      startAccount: 'The length is one character',//长度为1个数字或者字符
      isManufa:'The name contains 6 to 16 characters',//长度为6-16个数字,
      isAgreementId:'The name contains 6 to 16 characters or digits',//长度为6-16个字符或数字,
      isPort:'The value contains 0 to 6 digits',//长度为0-6个数字
      isIp:'Please enter a valid IP address',//请输入合法ip
      verifyValue:'The name contains 2 to 25 characters',//长度为2-25个字符
      isNotNUll:'Data cannot be null!',//数据不能为空
      order:'Enter numbers only',//只能输入数字
      checkPass: [
        "Re-input Password!", //请再次输入密码!
        "Different Password!", //两次输入密码不一致!
        "Unanimous Password"//两次输入的密码不能一致
      ],
      money: 'Pleaes input amont',//请输入金额!
      phone: "Input Phone", //请填写正确的手机号
      telPhone: "Input Tel", //请输入正确固定电话！
      email: "Wrong Email!", //邮箱格式不对!
      identification: "Input ID Card", //请输入合法身份证号码
      excelExoprt: {
        name: "Wrong name,Length in 2-10 characters （Required）",//名称格式不对,长度 2- 10字符 （必填）
        account: "Wrong account ,Length in 6-16 characters（Required）",//账号格式不对 ,不能有中文长度 6- 16字符（必填）
        password: "Wrong password ,Length in 6-15 characters（Required)",//密码格式不对 ,长度 6- 15字符（必填)
        phone: "Wrong phone",//密码格式不对 ,长度 6- 15字符（必填)
        identification: "Wrong ID Card（Required）",//身份证格式不对（选填）
        callLevel: "Call level format error",//通话等级格式错误
        groupType: "Group type call level format error",//群组类型错误
        funcs: "Function format error",//功能格式错误
        iccid: 'ICCID fomat mismatch,lenth should be 20',//iccid卡格式不符合，长度为20个字符
        imei: 'imei fomat mismatch,lenth should be 15',
        agreementId:'The name contains 6 to 16 characters',//长度为6-16个数字,
        isPort:'The value contains 0 to 6 digits',//长度为0-6个数字
        isIp:'Please enter a valid IP address',//请输入合法ip
        qb:'The number of Q coins can only be a number, and is greater than or equal to 0 and less than 10',//Q币数量只能是数字，且大于等于0，小于10
        order:'The order number can only be a number',//订单号只能为数字
      }
    }
  },

  organizationInfo: {
    addGroup: "Add a group of",//添加群
    currentOrganization: 'The current organization',//当前组织
    groupName: 'The name of the group',//群组名称
    account: 'Account',//账号
    name: 'Name',//名称
    failed: 'Failed',//失败
    correspondingOrganization: 'Please select the appropriate organization',//请选择对应的组织
    secManagement: 'The secondary management',//二级管理
    member: 'Member',//成员
    group: 'Group',//群组
    saveSuccess: "Save successfully",//保存成功
    add: 'Add',//添加
    delete: 'Delete',//删除
    addOrganization: 'Add Organization',//添加组织
    cancel: 'Cancel',//取消
    save: 'Save',//保存
    organizationInfo: 'Organization Info',//组织信息
    organizationName: 'Organization Name',//组织名称
    membershipInformation: 'Membership Information',//成员信息
    ourGroup: 'Our Group',//本组
    subunit: 'Subunit',//子组
    ourGroupMembers: 'Our Group Members',//本组成员
    deleteUser: 'Delete User',//删除用户
    authorityManagement: 'Authority Management',//权限管理
    schedulingPermissions: 'Scheduling Permissions',//调度权限
    groupPermission: 'Group Permission',//群组权限
    radioAccess: 'Radio Access',//广播权限
    affirm: 'Affirm',//确认
    cancelPermissions: 'Cancel Permissions',//权限权限
    childGroup: 'Child Group',//子组成员
    newAdd: 'newly increased ',//新增
    organizationTransfer: 'Organization Transfer',//组织转移
    membersMobile: 'Members Mobile',//移动成员
    organization: 'Organization',//所在组织
    tenOrganizations: 'A maximum of 10 organizational levels can be created',//最多只能创建10个组织层级
    selectOrganization: 'Please select organization',//请选择组织
    selectUser: 'Please select user',//请选择用户
    transferSuccess: 'Transfer success',//转移成功
    transferAgent: 'Transfer of agent organization',//代理组织转移
    moveEnterprise: 'To move the enterprise',//要转移企业
    pleaseChoose: 'please choose',//请选择
    organizeUser: 'Organize the user',//组织用户
    transferEnterprise: 'Transfer to the enterprise',//转移到企业
    confirmTransfer: 'Confirm the transfer',//确认转移
    enterpriseCannotTransferred: 'The same enterprise cannot be transferred',//同企业不能转移
    groupUser: 'Group member information',//群组成员信息
    groupInfo: 'Group Info',//群组信息
    hierarchy: 'Hierarchy',//层级
    function: 'Function',//功能
  },

  checkbox: {
    createTime: "Create Time", //创建时间
    enableTime: "Enable Time", //开始时间
    maturityTime: "Due Time", //到期时间
    modifyTime: "Modify Time", //修改时间
    operator: "Operator",//操作人
    origin: "From",//来源人
    target: "target",//目标人
    operationRole: "Operator Role",//操作人角色
    originRole: "Origin Role",//来源角色
    targetRole: "Target Role",//目标角色
    selectAll:"all",//全选

  },
  loading: {
    option: {
      text: "Data Loading..." //数据加载中...
    },
    text: {
      table: "Pls Wait..." //给我一点时间...
    }
  },
  error: {
    proxy: {
      fetch: {
        option: "fetch proxy fail"
      }
    },
    enterprise: {
      fetch: {
        option: "fetch enterprise fail"
      }
    }
  },
  prompt: {
    prompt: "Remind", //提示
    confirmButtonText: "Confirm", //确定
    cancelButtonText: "Cancel", //取消
    assignPassword: {
      title: "Input distributed password", //请输入分配密码
      errorMsg: "Password cannot be empty!" //密码不能为空！
    },
    oneClickLogin: "Is it a key to log in to the business?",
    import: "Do you import this data ？",
  },
  notify: {
    title: {
      login: "Login Notify",//登录通知
      orderBind:"Order Bind",//订单绑定
      success:"success",//成功
    },
    lastLogin: "Dear customer, your last loging time is: {time}, last login IP address is: {ip}", //尊敬的用户，您上次登录时间为: ${time}, 登录的IP地址为: ${ip}
    search: {
      enterprise: "Pls input company account first" //请先输入企业账号查询
    },
    cancel: "Cancel", //取消
    message:{
      bindingSucceeded:"Binding succeeded",//绑定成功
      transactionComplete:"Transaction complete",//交易完成
    },
  },
  operating: {
    success: {
      default: "Operate Success!",//操作成功!
      sync: "Sync Success!",//同步成功
    },
    error: {
      sync: "Syncing",
      default: "Operate Fail!", //操作失败!,
      password: "password Fail",//密码错误
      exportExcel: {
        template: "Please use the corresponding template!",//请使用对应的模板
        length: "You can only import up to 50 at a time!",//每次最多只能导入50条
        size: 'import a maximum of 100 lifetime free users!',//每次最多导入100条
        throwMessageByUser: {
          account: "Account required",//账号必填
          iccid: 'Iccid Requried',//iccid必填
          common: "Account：{account} , @:operating.error.exportExcel.select required",
          modelName: 'model required',//机型必填
          imei: 'imei required',//imei必填
        },
        throwMessageByGroup: " Name {name}  Required",//名称:{name} 必填
        select: "{type,select,account{Account} password{Password} name{Name} other{}}"
      }
    },
    warning: {
      capitalLimit: "Account{account}，capital limit！"//账号:{account}，Q币已经上限！
    },
    message: {
      insufficientBalance: "@:operating.error.default Insufficient Q Coin", //@:operating.error.default 剩余Q币不足
      language: "Switch Language Success！",
    }
  },
  msgbox: {
    title: {},
    message: {
      accountTransfer: [
        "Transfer target company:",//转移目标企业为
        "",
        "Number of transferred accounts:",//转移账户个数
        "个"
      ],
      balanceAssignResult: [
        "Total distribution:", //此次操作共分配
        "Q Coin", //Q币
        "Total distributed acount No.:", //共调整账户个数
        "Piece" //个
      ]
    }
  },
  unit: {
    //不知道 单位 个 单词是啥玩意
    ge: "Piece" //个
  },
  word: {
    name: "Name", //名称
    download: "Download", //下载
    account: "Account",//账号
    group: "Group",//群组
    subagen: "Subagen",//子代理
    proxy: "Proxy",//代理
    enterprise: "Enterprise",//企业
    terminal: "Terminal",//终端
    iccid: 'Iccid',//iccid卡号
    imei: 'IMEI',//imei号,
    domain: 'Dmain', // 域名
  },
  transfer: {
    placeholder: {
      user: "Input user name" //请输入用户名

    },
    buttonText: [
      "Delete", //删除
      "Add" //添加
    ],
    title: {
      user: [
        "User wait-to-add", //待添加用户
        "User added" //已添加用户
      ]
    }
  },
  dialog: {
    title: {
      modify: "Modify",//修改
      add: "Create",//新增
      friendMGT: "Friend MGT",//好友管理
      groupMGT: "Group MGT",//群组管理
      SecEnterprise: "Department MGT", //二级管理
      orderBind:"order bind",//订单绑定
      userBind:"user bind",//用户绑定
      purchaseOrder:"purchase order",//购买订单
      orderSplit:"order split",//订单拆分
      orderActive:"order active ",//订单激活
      orderDetails:"order details",//订单详情
      orderPaymentDetails:"Order payment details",//订单支付详情
      batchFunction:"Batch function setting",//批量功能设置
      bulkOrderSetup:"Bulk order setup",//批量订单设置
      batchQbSettings:"Batch QB Settings",//批量QB设置
    }
  },

  imei: {
    table: {
      imei: "Imei",
      modelName: "ModelName",//机器型号
      account: "Account",//账号
      userId: "Cser Id",//用户id
      createDate: "Create Date",//创建时间
      batch: "Batch",//批次号
      entId: "Enterprise Id",//企业id
      entAccount: "Enterprsie Account",//企业账号
      entName: "Enterprise Name",//企业名称
      proxyAccount: "Proxy Account",//代理账号
      proxyName: "Proxy Name",//代理名称
      subAccount: "Sub Account",//子代账号
      subName: "Sub name",//子代名称
      change: "Change Excel Row",
      iccid: "iccid",//iccid
    }
  },
  imeimessage: {
    warn: "infuse: ",//注
    modelIsNotNull: "Model Name is not null",//机器型号不能为空
    dataCheck: "start Data length ＋endDate length = fourteen",
    length: "The final data cannot be smaller than the starting data",//末数据不能小于始数据
    excelWarn: "Import,imei must be 15 digits. The starting column of the account in excel is not filled with the default value: b",//excel导入,imei必须为15数字.excel中的账号起始列,数据不填默认为:b
    imeiWarn: "When the interval is imported, the machine model must be selected, public data + start = 14, and public data + end = 14",//IMEI区间导入,机器型号必选,公共数据 + 始 = 14 且 公共数据 + 末 = 14 账号起始数据不填默认为: b
    imeiLength: "imei length = fourteen(input) + one(check bit)",//imei长度等于 = 14(输入) + 1(系统算出校验位);
  },
  alert:{
    head:{
      orderReminder:"Order reminder",//订单提示
    },
    title:{
      LoginDispatcherRequirements:"登录调度台要求：1 订单购买绑定调度功能，2 功能设置添加调度，3 组织管理设置调度权限等级",
      selectUserBindingOrder:"选择用户绑定订单，对已绑定订单的用户再次选择可以更新用户订单关系！",
      pleaseCheckIf:"Please check if the order has expired or new features have been added!",    //请检查订单是否到期或者新增功能
    },
    closeText:{
      know:"know",
    }

  },
  switch:{
    active:{
      cover:"cover",//覆盖
    },
    inactive:{
      notCovered:"not covered",//不覆盖
    }
  },
  tab:{
    label:{
      defaultOrder:"default order",//默认订单
      qbIntercomOrder:"Q coin intercom order",//Q币对讲订单
      transaction:"transaction",
    }
  },
  drawer:{
    title:{
      orderRenew:"Renew the order",//续签订单
      orderChange:"Change the order",//改签订单
    }
  },
  batch:{
    info:{
      termination:"Select the terminal that you want to terminate",//请选择需要终止的终端
      orderData:"Order data",//订单数据
      pleaseOrderNumber:"Please select the order number",//请选择订单号
      batchOrderHint:"To batch bind an order, first unbind the order that the selected user currently has",//要批量绑订单，请先解绑选择用户当前已有的订单
      secondaryEnterprise:"Select a secondary enterprise",//请选择二级企业
      changeQb:"Please select qb data or User id",//请选择qb数据或用户id
      unbound:"unbound",//已取消绑定
      changeOrderUser:"",//是否一键绑定当前所选用户
      hint:"Hint",//提示
      confirm:"Confirm",//确定
      cancel:"Cancel",//取消
      canceledUnbound:"Untying has been canceled",//已取消解绑
      unboundUser:"Whether to unbind the selected user with one click",//是否一键解绑当前所选用户
      batchSaveSecondry:"Whether to save secondary management in batches",//是否批量保存二级管理
      canceleSet:"unset",//取消设置
    }
  },
  //多语言模块
  errMsg,
  constant,
  table,
  operationLog,
  search,
  placeholder,
  qbLog,
  confirm,
  html,
  order,
  payLog,
  store,
};



// WEBPACK FOOTER //
// ./src/api/lang/en.js